import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PersonInsightsData } from 'src/app/hire-person-search/hire-insights/PersonInsightsData';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { GaEventsService } from 'src/app/_services/ga-events.service';
import { GlobalService } from 'src/app/_services/global.service';
import { environment } from 'src/environments/environment';
import { FreemiumService } from '../freemium.service';

declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009"
}
@Component({
    selector: 'app-webbtree-insights',
    templateUrl: './webbtree-insights.component.html',
    styleUrls: ['./webbtree-insights.component.scss'],
    standalone: false
})
export class WebbtreeInsightsComponent implements OnInit {

  personInsightsData: PersonInsightsData = {};
  isInsightsActive: boolean = true;
  currentCompanyInformation: CurrentCompanyInformation = {};
  @Output() updateInsightsEvent: EventEmitter<any> = new EventEmitter();


  constructor(private aggregationService: AggregationService,
    private freemiumService: FreemiumService, private gaService: GaEventsService
    ) {
      this.freemiumService.getInsightsProfileSection.subscribe(res=>{
        this.freemiumService.getfreemiumAggs();

     //   this.showInsightsSection = true;
       // this.onTabChange('insights');

    });
    this.freemiumService.getfreemiumAggs();

  }

  ngOnInit() {
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('bg-white');
    const insightsDataEvent = this.freemiumService.insightsFreemiumDataEvent.subscribe(data => {
      this.processIndividualData(data)
    });
         /**
     * GA tracking for Insights page visit
     */
          this.gaService.trackButtonClick('Insights_Page_View');
  }
  ngOnDestroy() {
    // delete this.research_form;
    let body = document.getElementsByTagName('body')[0];
    body.classList.remove('bg-ecf0f4');
  }
  private processIndividualData(data: any) {
    let agg = data?.data?.aggregations;
    if (data?.status !== "success" || !agg)
      return;
    const key = Object.keys(agg)[0];
    data[key] = data?.data?.aggregations[key];
    this.personInsightsData = this.freemiumService.processFreemiumTalentInsights(
      this.personInsightsData, data, { aggregatetype: key }
    );
    key === "location" &&  setTimeout(() => this.loadGoogleMap(this.personInsightsData), 100);

  }

  loadGoogleMap(personInsightsData: PersonInsightsData) {
    function drawMarkersMap() {
      try {
        var data = google.visualization.arrayToDataTable(
          personInsightsData.dataSourceWorkCountry
        );
        const continent = this.freemiumService.getRequestWithFilters().continentstobeincluded;
        var options = {
          region: `${
            CONTINENT_MAP[continent]
          }`,
          displayMode: "markers",
          colorAxis: {colors: ['#95E1D3', '#FFE3C4', '#FFA8A8', '#B9CFF9', '#F7EAA3', '#A3A3F7', 'A4FF94' ]},
        };
        const container = document.getElementById("workCountryChartDD");
        var chart = new google.visualization.GeoChart(container);
        chart.draw(data, options);
      } catch (error) {
        console.log('error in data visualisation in drawMakersMap :: ', error.message);
      }
    }

    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  getCompanyInfo(data: any) {
    let pastCompanyData = data;

    this.currentCompanyInformation['name'] = pastCompanyData?.name;
    this.currentCompanyInformation['industry'] = pastCompanyData?.industry;
    this.currentCompanyInformation['linkedin_url'] = pastCompanyData?.linkedin_url;
    this.currentCompanyInformation['location'] = pastCompanyData?.location?.name;
    this.currentCompanyInformation['size'] = pastCompanyData?.size;
    this.currentCompanyInformation['website'] = pastCompanyData?.website;
    this.currentCompanyInformation['companylogo'] = pastCompanyData.companylogo;
    this.currentCompanyInformation['tags'] = pastCompanyData.tags;
    this.currentCompanyInformation['id'] = pastCompanyData.id;
  }

  getIndustryIcon(industryName) {
    let iconName = GlobalService.getIndustryIcon(industryName);
    return `text-webbtree-black fa-solid fa-${iconName}`;
  }

  startFreeTrial(eventName: string) {
    this.updateInsightsEvent.emit({ status: 'scroll', eventName: eventName });

  }

}
